import { Grid } from '@mui/material';
import { PractitionerProfileCard } from './PractitionerProfileCard';
import { VideoRequirementsCard } from './VideoRequirementsCard';
import { SessionActionsCard } from './SessionActionsCard';

export function SessionDialogActions({
  guid,
  inSession
}: {
  guid?: string;
  inSession: boolean
}) {
  return (
    <Grid
      item
      md={4}
      xs={12}
    >
      <PractitionerProfileCard
        guid={guid} />
      <SessionActionsCard
        guid={guid}
        inSession={inSession}
      />
      <VideoRequirementsCard
        guid={guid} />
    </Grid>
  );
}
